import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const user: any =
  window.localStorage.getItem("user") &&
  window.localStorage.getItem("user") !== "undefined"
    ? JSON.parse(window.localStorage.getItem("user")!)
    : null;

const initialState: any = {
  user,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginUser: (state, action: PayloadAction<any>) => {
      localStorage.setItem("token", action.payload?.token);
      localStorage.setItem("user", JSON.stringify(action.payload?.user));
      state.user = action.payload?.user;
    },
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    logoutUser: (state, action: PayloadAction<any>) => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      state.user = null;
    },
  },
});

export const { loginUser, logoutUser, setUser } = authSlice.actions;

export const getUser = (state: RootState) => state.auth.user;

export default authSlice.reducer;
